import { useAppSelector } from "app/hooks";
import { useAuth } from "hooks/auth";
import { querystring } from "models/Listing";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import useSWR, { SWRResponse } from "swr";
import { ImportListItem } from "types/import";
import { ListResponse, ListingProps } from "types/listing";
import { getEnvVariable } from "utilities/env";

export function useImports() {
  const { code } = useAppSelector(selectCurrentStoreData);
  const { fetcher } = useAuth();

  const useImportsList = (
    props?: ListingProps,
  ): SWRResponse<ListResponse<ImportListItem>> => {
    return useSWR(
      () =>
        code
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/import${querystring(props)}`
          : null,
      fetcher,
    );
  };

  const useImportDetails = <T>(
    importId: string,
    props?: ListingProps,
  ): SWRResponse<ListResponse<T>> => {
    return useSWR(
      () =>
        code
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/import/${importId}${querystring(props)}`
          : null,
      fetcher,
    );
  };

  const importMembers = async (
    file?: string | Blob,
  ): Promise<{ data: { importId: string } }> => {
    const formData = new FormData();
    file && formData.append("import[file]", file);
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/${code}/import/member`,
      { body: formData, method: "post" },
    );
    const data = await response.json();
    if (response.ok) {
      return { data };
    } else {
      throw data;
    }
  };

  const importTransaction = async (
    file?: string | Blob,
  ): Promise<{ data: { importId: string } }> => {
    const formData = new FormData();
    file && formData.append("import[file]", file);
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/${code}/import/transaction`,
      { body: formData, method: "post" },
    );
    const data = await response.json();
    if (response.ok) {
      return { data };
    } else {
      throw data;
    }
  };

  return {
    importMembers,
    importTransaction,
    useImportDetails,
    useImportsList,
  };
}
